const __WEBPACK_NAMESPACE_OBJECT__ = require("amazon-cognito-identity-js");